import React from 'react';
import { noticeChipLabel, noticeHeldByMe, noticeLockedReason } from '../utils/noticeClaim';

// "Claimed by X" on a credit row — ONE chip for every list that shows credits
// (pickers, Transaction History, Money Available). Reads only the server's
// notice fields (utils/noticeClaim); renders nothing when nobody holds the
// notice. Amber when someone else holds it (the row is locked for you), green
// when it is yours.
function NoticeClaimChip({ row, user, style }) {
  const label = noticeChipLabel(row, user);
  if (!label) return null;
  const mine = noticeHeldByMe(row, user);
  return (
    <span
      className="notice-claim-chip"
      title={mine ? 'You claimed this payment — link it, assign it or classify it, or release it in Task Tracking.' : noticeLockedReason(row)}
      style={{
        display: 'inline-block',
        padding: '1px 8px',
        marginTop: 4,
        borderRadius: 10,
        fontSize: '0.75rem',
        fontWeight: 600,
        whiteSpace: 'nowrap',
        border: `1px solid ${mine ? '#a7f3d0' : '#fcd34d'}`,
        background: mine ? '#ecfdf5' : '#fffbeb',
        color: mine ? '#065f46' : '#92400e',
        ...style,
      }}
    >
      {label}
    </span>
  );
}

export default NoticeClaimChip;
